import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconRanksOff = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-ranks-off_svg__a)"
      d="M11.96 2.5c.704 0 1.29.586 1.29 1.25v5c0 .703-.586 1.25-1.29 1.25-.663 0-1.25-.547-1.25-1.25V6.797l-7.85 7.851a1.205 1.205 0 0 1-1.758 0 1.205 1.205 0 0 1 0-1.757L8.953 5H6.961c-.664 0-1.25-.547-1.25-1.25 0-.664.586-1.25 1.25-1.25h5Zm11.29 3.125c0 1.055-.86 1.875-1.875 1.875A1.851 1.851 0 0 1 19.5 5.625c0-1.016.82-1.875 1.875-1.875 1.016 0 1.875.86 1.875 1.875Zm-5 5c0 1.055-.86 1.875-1.875 1.875a1.851 1.851 0 0 1-1.875-1.875c0-1.016.82-1.875 1.875-1.875 1.016 0 1.875.86 1.875 1.875Zm-3.75 5c0-1.016.82-1.875 1.875-1.875 1.016 0 1.875.86 1.875 1.875 0 1.055-.86 1.875-1.875 1.875a1.851 1.851 0 0 1-1.875-1.875Zm3.75 5c0 1.055-.86 1.875-1.875 1.875a1.851 1.851 0 0 1-1.875-1.875c0-1.016.82-1.875 1.875-1.875 1.016 0 1.875.86 1.875 1.875Zm5 0c0 1.055-.86 1.875-1.875 1.875a1.851 1.851 0 0 1-1.875-1.875c0-1.016.82-1.875 1.875-1.875 1.016 0 1.875.86 1.875 1.875Zm-13.79-5c0-1.016.86-1.875 1.876-1.875 1.055 0 1.914.86 1.914 1.875 0 1.055-.86 1.875-1.914 1.875a1.875 1.875 0 0 1-1.875-1.875Zm3.79 5c0 1.055-.86 1.875-1.914 1.875a1.875 1.875 0 0 1-1.875-1.875c0-1.016.86-1.875 1.875-1.875 1.055 0 1.914.86 1.914 1.875Zm-8.79 0c0-1.016.86-1.875 1.876-1.875 1.055 0 1.875.86 1.875 1.875 0 1.055-.82 1.875-1.875 1.875a1.875 1.875 0 0 1-1.875-1.875Zm18.79-5c0 1.055-.86 1.875-1.875 1.875a1.851 1.851 0 0 1-1.875-1.875c0-1.016.82-1.875 1.875-1.875 1.016 0 1.875.86 1.875 1.875Zm-3.75-5c0-1.016.82-1.875 1.875-1.875 1.016 0 1.875.86 1.875 1.875 0 1.055-.86 1.875-1.875 1.875a1.851 1.851 0 0 1-1.875-1.875Z"
    />
    <defs>
      <linearGradient
        id="icon-ranks-off_svg__a"
        x1={23.5}
        x2={3.694}
        y1={2}
        y2={24.777}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF968D" />
        <stop offset={0.18} stopColor="#E2645A" />
        <stop offset={0.73} stopColor="#D83832" />
        <stop offset={1} stopColor="#AD3529" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconRanksOff;
